import type { FormEvent } from 'react';
import { useState } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';

interface RedeemPointsModalProps {
  show: boolean;
  onClose: () => void;
  onRedeem: (points: number) => Promise<void>;
  currentPoints: number;
}

export const RedeemPointsModal = ({ show, onClose, onRedeem, currentPoints }: RedeemPointsModalProps) => {
  const [points, setPoints] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const pointsValue = parseInt(points) || 0;
  const hasInsufficientPoints = pointsValue > currentPoints;

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!points || hasInsufficientPoints) {
      return;
    }

    setIsSubmitting(true);
    try {
      await onRedeem(pointsValue);
      setPoints('');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Redeem Points</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="mb-3">
            <strong>Available Points:</strong> {currentPoints?.toLocaleString() || '0'}
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Points to Redeem</Form.Label>
            <Form.Control
              type="number"
              value={points}
              onChange={(e) => setPoints(e.target.value)}
              min="1"
              max={currentPoints}
              placeholder="Enter points amount"
              required
            />
          </Form.Group>

          {hasInsufficientPoints && <Alert variant="danger">Insufficient points</Alert>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button variant="warning" type="submit" disabled={isSubmitting || hasInsufficientPoints || !points}>
            {isSubmitting ? 'Processing...' : 'Redeem'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
